import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Avatar, Box, Button, Chip, CircularProgress, Paper, Typography } from "@mui/material";
import { auth } from "../../firebase";
import PageHeader from "../PageHeader";
import { pageContentSx } from "../../pageLayout";
import { ORDER_STATUS, formatMoney, subscribeOrdersAsBuyer, timestampMs } from "./foodUtils";

const MyFoodOrders = () => {
  const uid = auth.currentUser?.uid;
  const [orders, setOrders] = useState(null);

  useEffect(() => {
    if (!uid) return undefined;
    return subscribeOrdersAsBuyer(uid, setOrders, () => setOrders([]));
  }, [uid]);

  return (
    <>
      <PageHeader title="Mis pedidos" />
      <Box sx={{ ...pageContentSx, maxWidth: { xs: "100%", md: 640 }, py: 2, pb: 6 }}>
        {orders === null && <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}><CircularProgress /></Box>}
        {orders && !orders.length && (
          <Box sx={{ textAlign: "center", py: 6 }}>
            <Typography sx={{ fontSize: 48 }}>🛵</Typography>
            <Typography color="text.secondary">Todavía no hiciste pedidos.</Typography>
            <Button component={Link} to="/pedidos" variant="contained" sx={{ mt: 2 }}>Pedir algo rico</Button>
          </Box>
        )}
        {orders?.map((order) => {
          const createdMs = timestampMs(order.createdAt);
          return (
            <Paper
              key={order.id}
              component={Link}
              to={`/pedidos/orden/${order.id}`}
              variant="outlined"
              sx={{ display: "flex", alignItems: "center", gap: 1.5, p: 1.5, mb: 1.5, borderRadius: 3, textDecoration: "none", color: "inherit" }}
            >
              <Avatar src={order.restaurantLogo} sx={{ bgcolor: "primary.main" }}>🍴</Avatar>
              <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                <Typography sx={{ fontWeight: 700 }} noWrap>{order.restaurantName}</Typography>
                <Typography variant="body2" color="text.secondary" noWrap>
                  {order.items.map((item) => `${item.qty}× ${item.name}`).join(", ")}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {createdMs ? new Date(createdMs).toLocaleString(undefined, { dateStyle: "short", timeStyle: "short" }) : ""}
                  {" · "}
                  {formatMoney(order.total, order.currency)}
                </Typography>
              </Box>
              <Chip label={ORDER_STATUS[order.status]?.label} color={ORDER_STATUS[order.status]?.color || "default"} size="small" />
            </Paper>
          );
        })}
      </Box>
    </>
  );
};

export default MyFoodOrders;
